"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROMOCODE_CONDITION_TYPE = void 0;
exports.PROMOCODE_CONDITION_TYPE = {
    PRODUCTS_IN_CART: 'PRODUCTS_IN_CART',
    SUBTOTAL_GREATER: 'SUBTOTAL_GREATER',
    QUANTITY_AND_NETTO_TOTAL_GREATER: 'QUANTITY_AND_NETTO_TOTAL_GREATER'
};
//# sourceMappingURL=promocodeConditionType.js.map